/* eslint-disable import/prefer-default-export */
/* disabling ^ while we only have one function here */

/**
 * Truncate a string without cutting words
 * Based on https://stackoverflow.com/a/5454303
 * @param {String} text the original string to truncate
 * @param {number} [max_length] How many characters of the string to display
 * @param {String} [end_char] optional string to append to the end of the
 * truncated string
 * @return {String}
 */
export function truncate(text, maxLength = 50, endChar = '') {
  if (text.length > maxLength) {
    let displayText = `${text} `.substr(0, maxLength);

    displayText = displayText.substr(
      0,
      Math.min(displayText.length, displayText.lastIndexOf(' '))
    );

    displayText += endChar;

    return displayText;
  }

  return text;
}

/**
 * Strip HTML from a string
 * @param {String} htmlString the original string containing HTML
 * stripped string
 * @return {String}
 */
export const stripHtml = (htmlString = '') =>
  htmlString.replace(/<[^>]+>/g, '');

/**
 * Strip hyphens from a string
 * @param {String} text the string that contains hyphens
 * @return {String}
 */
export const stripHyphens = text => text.replace(/-/g, ' ');

/**
 * Strip underscores from a string
 * @param {String} text the string that contains hyphens
 * @return {String}
 */
export const stripUnderscores = text => text.replace(/_/g, ' ');

/**
 * Capitalize the first letter in a string
 * @param {String} text the string to capitalize
 * @return {String}
 */
export const capitalize = text => text.charAt(0).toUpperCase() + text.slice(1);

/**
 * Capitalize all words in a string
 * @param {String} text the string in which to capitalize words
 * @return {String}
 */
export const capitalizeWords = text =>
  text
    .split(' ')
    .map(capitalize)
    .join(' ');
